import 'slick-carousel';

window.__IMAGE_GALLERY_VARIANT = 'A';

const galleryOptions = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: window.matchMedia('(min-width: 768px)').matches,
  dots: window.matchMedia('(max-width: 425px)').matches,
  prevArrow: `
  <div class="navigation">
    <button class="navigation__button" id="prev" aria-label="Previous" type="button">
    <svg aria-hidden="true" width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.07063 6.50001L6.60479 8.7526C7.01758 9.11952 7.05476 9.75159 6.68784 10.1644C6.32092 10.5772 5.68885 10.6143 5.27607 10.2474L0.787411 6.2575C0.76889 6.2415 0.750839 6.22471 0.733301 6.20714C0.651207 6.12519 0.586157 6.03203 0.53842 5.93232C0.472805 5.79559 0.440367 5.64762 0.44042 5.50001C0.440512 5.24269 0.539345 4.98649 0.733301 4.79288C0.750845 4.77531 0.768904 4.75851 0.78743 4.7425L5.27607 0.752601C5.68885 0.385683 6.32092 0.422864 6.68784 0.835647C7.05476 1.24843 7.01758 1.8805 6.60479 2.24742L4.07063 4.50001L24.9404 4.50001C25.4927 4.50001 25.9404 4.94773 25.9404 5.50001C25.9404 6.0523 25.4927 6.50001 24.9404 6.50001L4.07063 6.50001Z" fill="black"></path>
    </svg>
  </button>
  </div>
`,
  nextArrow: `
  <div class="navigation">
    <button class="navigation__button" id="next" aria-label="Next" type="button">
    <svg aria-hidden="true" width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9728 4.49999L20.4387 2.2474C20.0259 1.88048 19.9887 1.24841 20.3556 0.835626C20.7225 0.422843 21.3546 0.385662 21.7674 0.752581L26.256 4.7425C26.2746 4.7585 26.2926 4.77529 26.3102 4.79286C26.3923 4.87481 26.4573 4.96797 26.505 5.06768C26.5707 5.20441 26.6031 5.35238 26.603 5.49999C26.6029 5.75731 26.5041 6.01351 26.3102 6.20712C26.2926 6.22469 26.2746 6.24149 26.256 6.2575L21.7674 10.2474C21.3546 10.6143 20.7225 10.5771 20.3556 10.1644C19.9887 9.75157 20.0259 9.1195 20.4387 8.75258L22.9728 6.49999L2.10303 6.49999C1.55074 6.49999 1.10303 6.05227 1.10303 5.49999C1.10303 4.9477 1.55074 4.49999 2.10303 4.49999L22.9728 4.49999Z" fill="black"></path>
    </svg>
  </button>
  </div>
`,
  asNavFor: '.product-thumb__photos-slider',
};

const thumbGalleryOptions = {
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '#product-image-gallery',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: window.matchMedia('(max-width: 767px)').matches,
  accessibility: window.matchMedia('(max-width: 639px)').matches,
};

const initThumbGallery = function () {
  if (window.matchMedia('(min-width: 640px)').matches) {
    $('.product-thumb__photos-slider').find('.slick-cloned').remove();
    $('.product-thumb__photos-slider .slick-slide').attr(
      'aria-hidden',
      'false'
    );
  }
};

const pauseAllVideos = function () {
  const videos = document.querySelectorAll('.product-single__photo video');

  videos.forEach((video) => {
    if (video instanceof HTMLVideoElement) {
      video.pause();
    }
  });
};

const changeVariantImage = function (
  e: CustomEvent<{ variant: any; isFirstLoad: boolean }>
) {
  const variant = e.detail?.variant;
  const isFirstLoad = e.detail?.isFirstLoad || false;

  if (!variant) {
    return;
  }

  const variantId = variant.id;
  const slickSlide = document.querySelector(`.media-variant-${variantId}`);
  const gallery = jQuery('#product-image-gallery');

  if (!(slickSlide instanceof HTMLElement)) {
    return;
  }

  const slickIndex = parseInt(slickSlide.dataset.slickIndex || '1');

  gallery.slick('slickGoTo', slickIndex, isFirstLoad);
};

const selectCurrentThumbnail = () => {
  const activeThumbnailButton = document.querySelector(
    '.thumb-photo-button.slick-active'
  );

  if (!activeThumbnailButton) {
    return;
  }

  const activeThumbnailButtonSlickIndex =
    activeThumbnailButton?.getAttribute('data-slick-index');

  const photoButtons = document.querySelectorAll('.thumb-photo-button');

  photoButtons.forEach((button) => {
    button.removeAttribute('aria-current');
  });

  const currentButton = document.querySelector(
    `.thumb-photo-button[data-slick-index="${activeThumbnailButtonSlickIndex}"]`
  );

  if (currentButton instanceof HTMLElement) {
    currentButton.setAttribute('aria-current', 'true');
  }
};

const onVariantChange = function (e: CustomEvent | Event) {
  pauseAllVideos();
  changeVariantImage(e as CustomEvent);
};

const configSearchParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('variant')) {
    const variantId = searchParams.get('variant');

    const variantChange = new CustomEvent('variant:change', {
      detail: {
        variant: {
          id: variantId,
        },
        isFirstLoad: true,
      },
    });
    document.dispatchEvent(variantChange);
  }
};

const configZoomFeature = (gallery: JQuery<HTMLElement>) => {
  const images = document.querySelectorAll<HTMLImageElement>(
    '#product-image-gallery .product-single__photo img'
  );

  if (!gallery.get(0)) {
    return;
  }

  gallery.get(0).addEventListener('dragstart', () => {
    window.IS_GALLERY_DRAGGING = true;
  });

  gallery.get(0).addEventListener('dragend', () => {
    setTimeout(() => {
      window.IS_GALLERY_DRAGGING = false;
    }, 1);
  });

  document.querySelector('.zoom-indicator')?.addEventListener('click', () => {
    const galleryElement = gallery.get(0);
    if (!galleryElement || !('slick' in galleryElement)) {
      return;
    }

    const slick = galleryElement.slick as JQuerySlick;

    const currentSlideIndex = slick.currentSlide;
    const currentSlide = (slick.$slides || [])[currentSlideIndex];

    const currentImage = currentSlide.querySelector(
      '.product-single__photo > img'
    );
    if (currentImage instanceof HTMLImageElement) {
      currentImage.click();
    }
  });

  images.forEach((image) => {
    image.addEventListener('click', (event) => {
      if (window.IS_GALLERY_DRAGGING) {
        window.IS_GALLERY_DRAGGING = false;
        return;
      }
      const container = document.querySelector(
        '.product-single__photos-wrapper'
      );
      const zoomContainer = document.createElement('div');
      zoomContainer.classList.add('zoom-container-wrapper');
      zoomContainer.setAttribute('role', 'region');
      zoomContainer.setAttribute('aria-label', 'image with zoom functionality');
      zoomContainer.innerHTML = `
        <div class='zoom-container'>
            <div class="zoom-container__close">
                <button type="button" class="btn btn--secondary btn--small" id="zoom-close" title="close zoomed image" aria-label="close zoomed image">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0A0A0A"/>
                    </svg>
                </button>
            </div>
            <div class="zoom-container__image">
                <img src="${image.src}" alt="${image.alt}" style="transform: scale(1) translate(0, 0);">
                <div class="zoom-instructions" role="alert" aria-live="polite">
                    Use +/- to zoom in/out. Use arrow keys to pan.
                </div>
            </div>
        </div>
        `;

      let timeout: NodeJS.Timeout;
      const zoomImage = zoomContainer.querySelector<HTMLImageElement>(
        '.zoom-container__image img'
      );

      zoomImage?.setAttribute('tabindex', '0');
      zoomImage?.focus();

      let scale = 1;
      const maxScale = 2;
      let translateX = 0;
      let translateY = 0;
      const zoomStep = 0.1;
      const panStep = 40;

      function updateTransform() {
        if (!(zoomImage instanceof HTMLElement)) {
          return;
        }

        zoomImage.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
      }

      zoomContainer.addEventListener('keydown', (event) => {
        switch (event.key) {
          case '+':
          case '=':
            scale = Math.min(scale + zoomStep, maxScale);
            break;
          case '-':
            scale = Math.max(scale - zoomStep, 1);
            break;
          case 'ArrowUp':
            translateY += panStep;
            break;
          case 'ArrowDown':
            translateY -= panStep;
            break;
          case 'ArrowLeft':
            translateX += panStep;
            break;
          case 'ArrowRight':
            translateX -= panStep;
            break;
          case 'Escape':
            zoomContainer.remove();
            return;
        }

        if (zoomImage instanceof HTMLImageElement) {
          const scaledWidth = zoomImage?.naturalWidth * scale;
          const scaledHeight = zoomImage?.naturalHeight * scale;

          const containerRect = container?.getBoundingClientRect();
          const imageRect = zoomImage.getBoundingClientRect();

          if (!containerRect || !imageRect) {
            return;
          }

          const maxTranslateX = Math.max(0, scaledWidth - containerRect.width);
          const maxTranslateY = Math.max(
            0,
            scaledHeight - containerRect.height
          );

          // Clamp values to keep the image within bounds
          translateX = Math.min(
            maxTranslateX,
            Math.max(-maxTranslateX, translateX)
          );
          translateY = Math.min(
            maxTranslateY,
            Math.max(-maxTranslateY, translateY)
          );

          if (translateX > 0) {
            translateX = 0;
          }

          if (translateY > 0) {
            translateY = 0;
          }
        }
        updateTransform();
        event.preventDefault();
      });
      zoomContainer.addEventListener('mousemove', (event: MouseEvent) => {
        if (!window.matchMedia('(min-width: 768px)').matches) {
          return;
        }

        const containerRect = container?.getBoundingClientRect();
        const imageRect = zoomImage?.getBoundingClientRect();

        if (!containerRect || !imageRect) {
          return;
        }

        const mouseX = event.clientX - containerRect.left;
        const mouseY = event.clientY - containerRect.top;

        const percentX = mouseX / containerRect.width;
        const percentY = mouseY / containerRect.height;

        const imageX = (imageRect.width - containerRect.width) * percentX;
        const imageY = (imageRect.height - containerRect.height) * percentY;

        translateX = -imageX;
        translateY = -imageY;
        updateTransform();
      });
      zoomContainer.addEventListener('mouseenter', () => clearTimeout(timeout));
      zoomContainer.addEventListener('mouseleave', (event) => {
        clearTimeout(timeout);
        if (
          !(event.relatedTarget instanceof HTMLElement) ||
          event.relatedTarget.closest('.zoom-container-wrapper')
        ) {
          return;
        }
        timeout = setTimeout(() => {
          zoomContainer.remove();
        }, 200);
      });

      if (window.matchMedia('(min-width: 768px)').matches) {
        container?.appendChild(zoomContainer);
      } else {
        document.body.appendChild(zoomContainer);
      }

      zoomContainer.setAttribute('tabindex', '0');
      zoomContainer.focus();

      event.stopImmediatePropagation();
    });
  });

  const closeZoomedImage = (event: Event) => {
    if (
      event.target instanceof Element &&
      event.target.matches('#zoom-close, #zoom-close *')
    ) {
      document.querySelector('.zoom-container-wrapper')?.remove();
      document.querySelector<HTMLElement>('.zoom-indicator')?.focus();
    }
  };

  const closeZoomedImageOnEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      document.querySelector('.zoom-container-wrapper')?.remove();
      document.querySelector<HTMLElement>('.zoom-indicator')?.focus();
    }
  };

  document.removeEventListener('click', closeZoomedImage);
  document.addEventListener('click', closeZoomedImage);
  window.removeEventListener('keydown', closeZoomedImageOnEscape);
  window.addEventListener('keydown', closeZoomedImageOnEscape);
};

const setAriaThumbGallery = () => {
  const photoButtons = document.querySelectorAll('.thumb-photo-button');

  if (!photoButtons.length) {
    return;
  }

  const handleClickImage = (event: Event) => {
    photoButtons.forEach((button) => {
      button.removeAttribute('aria-current');
    });

    if (event.currentTarget instanceof HTMLElement) {
      event.currentTarget?.setAttribute('aria-current', 'true');
    }
  };

  photoButtons.forEach((button) => {
    if (button.classList.contains('slick-current')) {
      button.setAttribute('aria-current', 'true');
    } else {
      button.removeAttribute('aria-current');
    }
  });

  photoButtons.forEach((photo) => {
    photo.removeEventListener('click', handleClickImage);
    photo.addEventListener('click', handleClickImage);
  });
};

const checkIfMultipleImages = () => {
  const gallery = document.querySelector('.product-single__photos');

  if (!gallery) {
    return;
  }

  const images = gallery.querySelectorAll('.product-single__photo');

  if (images.length > 1) {
    return;
  }

  // remove padding from .slick-list
  gallery
    .querySelector('.slick-list')
    ?.setAttribute('style', 'padding: 0 0 0 0 !important;');
};

const changeRoleFromSlides = () => {
  // Changes role="option" to role="group" from slides of main gallery
  // This role is added by default by slick.js
  const slides = document.querySelectorAll(
    '#product-image-gallery .product-single__photo-wrapper'
  );

  if (!slides.length) {
    return;
  }

  slides.forEach((slide) => {
    if (slide instanceof HTMLElement) {
      slide.setAttribute('role', 'group');
    }
  });
};

const init = () => {
  const gallery = jQuery('#product-image-gallery');
  const thumbGallery = jQuery('.product-thumb__photos-slider');

  if (!gallery.get(0) || !thumbGallery.get(0)) {
    return;
  }

  gallery.on('init reInit afterChange', function (_event, slick) {
    if (!slick.slideCount) {
      return;
    }

    const pageInfo = $('.page-info');

    const i = (slick.currentSlide ? slick.currentSlide : 0) + 1;

    pageInfo.text(i + '/' + slick.slideCount);

    selectCurrentThumbnail();
  });

  thumbGallery.on('init', initThumbGallery);

  gallery.slick(galleryOptions);

  document
    .querySelector('.product-single__photos')
    ?.classList.remove('loading');

  gallery.on('beforeChange', pauseAllVideos);

  thumbGallery.slick(thumbGalleryOptions);

  if (window.matchMedia('(min-width: 640px)').matches) {
    thumbGallery.on('afterChange', function () {
      $('.product-thumb__photos-slider .slick-slide').attr(
        'aria-hidden',
        'false'
      );
    });
  }

  document.removeEventListener('variant:change', onVariantChange);
  document.addEventListener('variant:change', onVariantChange);

  setAriaThumbGallery();
  changeRoleFromSlides();
  configSearchParams();
  configZoomFeature(gallery);
  checkIfMultipleImages();
};

const destroySlickConfig = () => {
  const gallery = jQuery('#product-image-gallery');
  const thumbGallery = jQuery('.product-thumb__photos-slider');

  if (!gallery.get(0) || !thumbGallery.get(0)) {
    return;
  }

  if (gallery.hasClass('slick-initialized')) {
    gallery.off('init reInit afterChange');
    gallery.off('beforeChange');
    gallery.slick('unslick');
  }

  if (thumbGallery.hasClass('slick-initialized')) {
    thumbGallery.off('init');
    thumbGallery.slick('unslick');
  }
};

export const initSlickGallery = () => {
  document.addEventListener('theme:ready', init);
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('resize', () => {
    destroySlickConfig();
    init();
  });
};
